import TIM from '@tencentcloud/chat';

export default TIM;
